<template>
	<button
		@click="$emit('on:Click')"
		v-bind="$attrs"
		:class="class"
		:disabled="disabled"
	>
		{{ loading ? "" : label }}
		<cc-ball-clip-rotate v-if="loading"></cc-ball-clip-rotate>
	</button>
</template>
<script>
	// import { watch } from "vue";
	export default {
		props: {
			id: {
				type: [String, Number],
				default: null,
			},
			class: {
				type: [String, Number],
				default: "btn",
			},
			label: {
				type: [String, Number],
				default: null,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			loading: {
				type: Boolean,
				default: false,
			},
		},
		emits: ["on:Click"],
	};
</script>

<style scoped>
	button {
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		/* background: #41a1e3;
		border-color: #41a1e3; */
	}
	.loginBtn {
		background-image: linear-gradient(45deg, #00A0E3,#F4BB22);
		border-radius: 10px;
		margin-top: 2.8rem;
		color: #fff;
		font-size: 1.4rem;
	}
	button:disabled {
		cursor: not-allowed;
		pointer-events: all;
		background-image: linear-gradient(45deg, #00A0E3,#F4BB22);
	}
</style>
